/*
 * @Description:
 * @Date: 2021-09-26 15:02:05
 */
import http from '@/utils/http/axios';
import { MenuList, ResourceList, EntpRnv } from './types';
import { wwwConfig } from '@/utils/http/axios/content-type';
import { menuListTranslator } from './translators';

enum Api {
  logOut = '/back-end/api/v1/userSignIn/user/logOut', // 退出登录
  resourceList = '/back-end/api/v1/userSignIn/user/resourceList', // 当前用户页面权限
  menuList = '/back-end/api/v1/userSignIn/user/menuList', // 菜单列表
  entpRnv = '/back-end/api/v1/entp/entpRnv', // 查询企业认证状态
  setAPassword2 = '/back-end/api/v1/userSignIn/user/setAPassword2', // 重置密码
  lastProtocol = '/back-end/protocol/lastProtocol', // 协议管理-获取注册协议
  queryUserInfo = '/back-end/api/v1/userSignIn/user/queryUserInfo', // 获取当前用户信息
  queryFunction = '/back-end/api/v1/userSignIn/user/queryFunction', // 查询当前登录的用户 具有哪些职能
  cutFunction = '/back-end/api/v1/userSignIn/user/cutFunction' // 当前用户切换职能
}

export const logOut = async () =>
  http.request({
    url: Api.logOut,
    method: 'POST'
  });
export const resourceList: ResourceList = async params =>
  http.request(
    {
      url: Api.resourceList,
      method: 'POST',
      params
    },
    { ...wwwConfig }
  );
// 菜单都要在yapi mock中写全，方便测试注册菜单： http://yapi.jimijiayuan.cn/project/1287/interface/api/30920
export const menuList: MenuList = async () => {
  const resp = await http.request(
    {
      url: Api.menuList,
      method: 'POST'
    }
    // { yapi: 1287 }
  );
  return menuListTranslator(resp);
};
export const entpRnv: EntpRnv = async () =>
  http.request(
    {
      url: Api.entpRnv,
      method: 'POST'
    }
    // { yapi: 1287 }
  );

export const setAPassword2 = async (params: {
  password: string;
  passwordTwo: string;
}) =>
  http.request({
    url: Api.setAPassword2,
    method: 'POST',
    params
  });

export const lastProtocol = async (params?) =>
  http.request(
    {
      url: Api.lastProtocol,
      method: 'GET',
      params
    },
    {
      ...wwwConfig
    }
  );

export const queryUserInfo = async (params?) =>
  http.request(
    {
      url: Api.queryUserInfo,
      method: 'POST',
      params
    },
    {
      ...wwwConfig
    }
  );
export const queryFunction = async (params?) =>
  http.request(
    {
      url: Api.queryFunction,
      method: 'POST',
      params
    },
    {
      ...wwwConfig
    }
  );
export const cutFunction = async (params: { functionCode: 1 | 2 | 3 }) =>
  http.request(
    {
      url: Api.cutFunction,
      method: 'POST',
      params
    },
    {
      ...wwwConfig
    }
  );
